<!-- eslint-disable max-len -->
<template>
    <div>
      <div style="height: 20px;"/>
      <h2>Purchase Required for {{course.className}}</h2>
      <div style="height: 10px;"/>
      <p style="font-size: 18px;">The {{classTypeNameLower}} you are trying to access requires a payment of
        <span :style="basePriceStyle">{{baseCostString}}</span><span v-if="paymentData.activePrice !== paymentData.basePrice" class="active-cost-label"> {{activeCostString}}</span>.
      </p>
      <coupon-entry
          @coupon-applied="(c)=>$emit('coupon-applied', c)"
          ref="couponEntry"
          :paymentData="paymentData"
          :course="course"
        />
      <button
        style="position: absolute; bottom: 40px; right: 40px; width: 150px; z-index: 1000;"
        class="btn" :disabled="shouldDisableContinue" @click="$emit('continue')">Continue</button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CouponEntry from '../CouponEntry';

export default {
  components: {
    CouponEntry
  },
  props: {
    course: Object,
    paymentData: Object
  },
  computed: {
    ...mapGetters([
      'classTypeNameLower',
    ]),
    basePriceStyle() {
      if (this.paymentData.basePrice !== this.paymentData.activePrice) {
        return 'text-decoration: line-through; color: gray;';
      }
      return 'font-weight: bold;';
    },
    activeCostString() {
      const price = this.paymentData.activePrice;
      return `$${price.toFixed(2)}`;
    },
    baseCostString() {
      const price = this.paymentData.basePrice;
      return `$${price.toFixed(2)}`;
    },
    shouldDisableContinue() {
      if (this.haveRefsLoaded && !this.haveRefsLoaded);
      return (this.$refs.couponEntry && this.$refs.couponEntry.processing);
    }
  },
  async mounted() {
    await this.$nextTick();
    this.haveRefsLoaded = !this.haveRefsLoaded;
  },
  data() {
    return {
      haveRefsLoaded: false,
      couponCode: '',
      activeCouponData: {
        isActive: false,
        discount: 0
      },
      flowState: {

      }
    };
  }
};
</script>

<style lang="scss" scoped>
.active-cost-label
{
  color: red;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/braintree/purchase-flow-views/InfoPage.vue